/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Nav_AllInputs */

const cs_documents_nav_all = /** @type {(inputs: Documents_Nav_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všechny složky`)
};

const en_documents_nav_all = /** @type {(inputs: Documents_Nav_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All folders`)
};

/**
* | output |
* | --- |
* | "All folders" |
*
* @param {Documents_Nav_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_nav_all = /** @type {((inputs?: Documents_Nav_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Nav_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_nav_all(inputs)
	return cs_documents_nav_all(inputs)
});